import React, { createContext, useEffect, useRef, useState } from "react";
import useApi from "../service/api.service";

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const API = useApi();
  const intervalRef = useRef(null);
  const [notifData, setNotifData] = useState("asd");
  const [isNotificationVisible, setNotificationVisible] = useState(true);
  const [selectedItemIds, setSelectedItemIds] = useState([]);
  const [selectedItemIds1, setSelectedItemIds1] = useState([]);
  const [alertData, setAlertData] = useState([]);
  const [notifFlag, setNotifFlag] = useState(false);
  const [notifMessage, setNotifMessage] = useState("Hello");
  const [currentPage, setCurrentPage] = useState(null);
  const [currentRelationId, setCurrentRelationId] = useState(null);

  const updateAlertCriteria = (page, relationId) => {
    setCurrentPage(page);
    setCurrentRelationId(relationId);
  };

  const hideNotification = () => {
    setNotificationVisible(false);
  };

  const showNotification = () => {
    setNotificationVisible(true);
  };

  const getRealTimeData = async () => {
    try {
      const response = await API.getRealTimeData();
      const realTimeFlag = response?.data;
      if (realTimeFlag?.flag) {
        try {
          const response1 = await API.fetchAlertsData({ alertType: null });
          setAlertData(response1.data);
          setNotifMessage(response1?.data?.[0]?.alertMessage);
          setNotifFlag(realTimeFlag?.flag);
          localStorage.setItem("notifnew", JSON.stringify(response1?.data));
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      getRealTimeData();
    }, 30000);

    return () => clearInterval(intervalRef.current);
  }, []);

  const contextValue = {
    notifData,
    isNotificationVisible,
    hideNotification,
    showNotification,
    updateAlertCriteria,
    selectedItemIds,
    setSelectedItemIds,
    selectedItemIds1,
    setSelectedItemIds1,
    alertData,
    setAlertData,
    notifFlag,
    setNotifFlag,
    notifMessage,
  };

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
    </NotificationContext.Provider>
  );
};
